// Externals
import { createAction } from "@reduxjs/toolkit";

// Actions
export const updateMathces = createAction("UPDATE_MATCHES");
export const initMatches = createAction("INIT_MATCHES");
